import React from 'react'
import './TypeNav.css'
import { Menu } from 'antd'
import type { MenuProps } from 'antd'
import axios from 'axios'
import MenuItem from 'antd/es/menu/MenuItem'
import { useDispatch } from 'react-redux'
import { TypesMenuObj } from '../../../Routes/Home'
import { useSelector } from 'react-redux'
import { modalOptions, showModal } from '../../../redux/slices/ModalSlice'
import { setIsLoadingTrue, setIsLoadingFalse } from '../../../redux/slices/LoadingSlice'
import ModalComponent from '../../UI/ModalComponent'
import TypesModal from './TypesModal'



type MenuItem = Required<MenuProps>['items'][number]

export interface TypesMenuObjProps {
    setTypeItem: (([]) => void)
    setType: TypesMenuObj[]

}

const getItem = (
    label: React.ReactNode,
    key: React.Key,
    children?: MenuItem[],
    type?: 'group'
): MenuItem => {
return {
    key,
    children,
    label,
    type,
} as MenuItem
}
const items: MenuProps['items'] = [
    getItem('Fencing', 'sub1', [
        getItem('Wood Fencing Repair', '1'),
        // getItem('Aluminum Fencing', '2'),
        // getItem('Vinyl Fencing', '3'),
        // getItem('Chain Link Fencing', '4'),
        getItem("Barbed Wire Fencing", '5'),
        getItem("Pipe Fencing", '6'),
        getItem('Wrought Iron Fencing', '7'),
        getItem('Gates/Entry Ways', '8'),
        getItem('Fence Staining', '9')
    ]),
    {type: 'divider'},
    getItem('Welding', 'sub2', [
        getItem('Custom Fabrication', '10'),
        getItem('Pipe', '11'),
        getItem('Structural', '12')
    ])
]

const TypeNav = (props: TypesMenuObjProps) => {
    const modal = useSelector(modalOptions)
    const dispatch = useDispatch()
    const onClick: MenuProps['onClick'] = (e) => {
        dispatch(setIsLoadingTrue())
        console.log('click worked', e)
        console.log("e.key", e.key)
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getTypes${e.key}`)
        .then(res => {
            dispatch(setIsLoadingFalse())
        props.setTypeItem([...res.data])
            dispatch(showModal('types'))
            console.log("Type:",res.data)
        })
        .catch(err => {
            console.log("Types Err", err)
        })
    }
return (
    <aside className="aside">
        <Menu 
        onClick={onClick}
        className="side-menu"
        items={items}
        mode="inline"
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        theme="dark"
        />

        <ModalComponent className="type-modal-width" modalName={'types'}>
        <TypesModal setType={props.setType} setTypeItem={props.setTypeItem} />
        </ModalComponent>


    </aside>
)
}

export default TypeNav
